// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-components-document-body-js": () => import("./../../../src/components/DocumentBody.js" /* webpackChunkName: "component---src-components-document-body-js" */)
}

